
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import Allergen from "@/model/Allergen";
import {FETCH_ALLERGEN_LIST, FETCH_FOOD_ITEM_IMAGES} from "@/store/action-types";
import {TranslateResult} from "vue-i18n";
import AllergenDetail from "@/model/AllergenDetail";
import {Action} from "vuex-class";
import DetailImageDialog from "@/components/order/DetailImageDialog.vue";

@Component({
  components: {
    DetailImageDialog
  }
})
export default class InfoMenuGroupItemDialog extends Vue {
  @Prop({type: Boolean, default: false}) readonly show!: boolean
  @Prop({type: Object, required: true}) readonly selectedItem!: AllergenDetail
  @Action(FETCH_FOOD_ITEM_IMAGES) fetchFoodItemImageList!: ({ (payload: any): Promise<any> })

  private fetchInProgress = false
  private allergensList: Allergen[] | null = []
  private showSnackBar: boolean = false
  private snackBarText: TranslateResult | string = ''
  private snackBarColor: string = ''
  private tab: number | null = null
  private showDetailImageDialog: boolean = false
  private indexItem: number | null = null

  getImage (item: any): any {
    return `/api/food-database/food-item-media/${item.id}/data`
  }

  getAllergenClass (item: string): string {
    if(this.selectedItem.allergens.find((i: Allergen) => i.code === item)) {
      return 'text-allergen-style'
    } else {
      return 'text-style'
    }
  }

  onCloseDialogClick () {
    this.$emit('close')
  }

  onDetailImageClick(item: number): void {
    this.showDetailImageDialog = true
    this.indexItem = item
  }

  onCloseDetailImageClick(): void {
    this.showDetailImageDialog = false
  }

  async fetchAllergens ():Promise<void> {
    this.fetchInProgress = true
    try{
      this.allergensList = await this.$store.dispatch(FETCH_ALLERGEN_LIST)
    }catch (e) {
      this.snackBarColor = 'error'
      this.snackBarText = this.$t('errors.fetchDataError')
      this.showSnackBar = true
    }finally {
      this.fetchInProgress = false
    }
  }

  mounted(): void {
    this.fetchAllergens()
  }

}
